import * as React from 'react';
import { Image } from '@cian/ui-kit/image';
import { InlineText2 } from '@cian/ui-kit/typography';
import classNames from 'classnames';
import { ILayout } from '../../types/newbuilding/layouts';
import * as styles from './LayoutsPreview.css';
import { TourIcon } from './parts/TourIcon';

export interface ILayoutsPreviewProps {
  layouts: ILayout[];
  selectedLayout: number;
  selectLayout(index: number): void;
}

export const LayoutsPreview: React.FC<ILayoutsPreviewProps> = props => {
  const { layouts, selectedLayout, selectLayout } = props;

  return (
    <div className={styles['container']}>
      {layouts.map((layout, index) => (
        <div key={`layout${index}`} className={styles['preview']} onClick={() => selectLayout(index + 1)}>
          <div className={classNames(styles['image'], index === selectedLayout - 1 && styles['selected'])}>
            <Image src={layout.image.thumbnailUrl} width={65} height={65} objectFit={'contain'} />
            {layout.tourUrl && (
              <div className={styles['tour_icon']}>
                <TourIcon />
              </div>
            )}
          </div>
          <InlineText2>{layout.totalArea}</InlineText2>
        </div>
      ))}
      <div aria-hidden className={styles['placeholder']} />
      <div aria-hidden className={styles['placeholder']} />
      <div aria-hidden className={styles['placeholder']} />
    </div>
  );
};
